// TODO get this content from standard text API?
import Image from "next/legacy/image";
import styles from "./Usps.module.scss";

// Since we dont pass in hotel id in the hotels index.tsx, we can pass in the hotel id optionally for components.
interface UspsProps {
    hotelId?: string
}

export function Usps({hotelId}: UspsProps){

    // 336155 = Universal Helios Grand Hotel, a Loews Hotel
    const idsWithUspExpressNotIncluded = ['336155'];
    let showUniversalExpressUsp = !hotelId || !idsWithUspExpressNotIncluded.includes(hotelId) ? true : false;
    
    return (
        <div className={styles.usps}>
            {(showUniversalExpressUsp) && (
            <div className={styles.uspItem}>
                <div className={styles.img}>
                    <Image src='/usps/uspExpress.svg' width={60} height={60} alt='Universal Express Unlimited' priority />
                </div>
                    <h2>Universal Express Unlimited</h2>
                    <p>Staying at select Signature Collection Hotels allows you to skip the regular lines at participating park attractions.</p>
            </div>
            )}
            <div className={styles.uspItem}>
                <div className={styles.img}>
                    <Image src='/usps/uspEarly.svg' width={60} height={60} alt='Early Park Admission' priority />
                </div>
                <h2>Early Park Admission</h2>
                <p>Breeze into one of our three amazing theme parks up to an hour early.</p>
            </div>
            <div className={styles.uspItem}>
                <div className={styles.img}>
                    <Image src='/usps/uspTransport.svg' width={60} height={60} alt='Complimentary Transportation' priority />
                </div>
                <h2>Complimentary Transportation</h2>
                <p>Get to the parks in one of our complimentary water taxis or shuttle buses and get to the fun fast.</p>
            </div>
        </div>
    )
}